<template>
    <div class="contact">
        <sep name="L"></sep>

        <main-container>
            <contact-teaser />
        </main-container>

        <sep name="L"></sep>

        <main-container>
            <h2>
                <typo name="title-30-normal">{{ dico.title }}</typo>
            </h2>
            <p>
                <typo name="body-16-normal">{{ dico.text }}</typo>
            </p>
            <sep name="L"></sep>
            <contact-form v-if="user" :user="user" />
        </main-container>
        <scroll-top />
    </div>
</template>
<script>
import Vue from "vue";
import ScrollTop from "../common/scrollTop/ScrollTop.vue";
import ContactForm from "./ContactForm.vue";
import ContactTeaser from "./ContactTeaser.vue";

export default Vue.extend({
    components: {
        ContactTeaser,
        ContactForm,
        ScrollTop,
    },
    props: ["user"],
    computed: {
        dico() {
            return this.$publicDico.contact.form;
        },
    },
});
</script>

<style lang="sass" scoped>
.typo
    color: $color-text
</style>
